import React, { useLayoutEffect, useRef } from 'react';

// Campo de texto de varias líneas que crece con lo escrito: arranca con
// `minRows` renglones y va creciendo hasta `maxRows`; a partir de ahí aparece
// la barra de desplazamiento. Se usa en los conceptos de facturas y proformas,
// donde el texto va desde una línea hasta párrafos enteros.
const AutoGrowTextarea = ({
  value,
  onChange,
  minRows = 3,
  maxRows = 10,
  className = 'form-input',
  style,
  ...props
}) => {
  const ref = useRef(null);

  // Se recalcula tras cada render (también al cargar una factura existente o al
  // aplicar una plantilla), no solo al teclear.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const estilos = window.getComputedStyle(el);
    const alturaLinea = parseFloat(estilos.lineHeight) || parseFloat(estilos.fontSize) * 1.4;
    const extra = parseFloat(estilos.paddingTop) + parseFloat(estilos.paddingBottom)
      + parseFloat(estilos.borderTopWidth) + parseFloat(estilos.borderBottomWidth);
    const alturaMinima = alturaLinea * minRows + extra;
    const alturaMaxima = alturaLinea * maxRows + extra;

    el.style.height = 'auto';
    const alturaContenido = el.scrollHeight;
    const altura = Math.min(Math.max(alturaContenido, alturaMinima), alturaMaxima);
    el.style.height = `${altura}px`;
    el.style.overflowY = alturaContenido > alturaMaxima ? 'auto' : 'hidden';
  }, [value, minRows, maxRows]);

  return (
    <textarea
      ref={ref}
      className={className}
      value={value ?? ''}
      onChange={onChange}
      rows={minRows}
      style={style}
      {...props}
    />
  );
};

export default AutoGrowTextarea;
